import {ITextFieldProps, TextField, Text, Checkbox} from '@fluentui/react';
import {FC, useEffect, useState} from 'react';
import styles from './PublishProcessCommentModal.module.scss';
import { ModalWithHeader } from '../ModalWithHeader';
import { FormFooter } from '../FormFooter';
import { IPublishProcessCommentModalProps } from './IPublishProcessCommentModalProps';

export const PublishProcessCommentModal: FC<IPublishProcessCommentModalProps> = ({
  isVisible,
  dismiss,
  onApproveModal,
  processPublicationComment,
  onProcessPublicationCommentChange,
}) => {

  const [sentNotification, setSentNotification] = useState(true);

  useEffect(() => {
  if (isVisible) {
    setSentNotification(true);
  }
}, [isVisible]);

  return (
    <ModalWithHeader
              dismiss={dismiss}
              isVisible={isVisible}
              header={"Comment"}>
              <div className={styles.formWrapper}>
                <TextField
                  multiline
                  resizable={false}
                  value={processPublicationComment}
                  onChange={onProcessPublicationCommentChange}
                  description={processPublicationComment.length.toString() + '/1024'}
                  onRenderDescription={(props: ITextFieldProps | undefined) => (
                    <Text variant="small" styles={{root: {float: 'right'}}}>
                      {props?.description}
                    </Text>
                  )}></TextField>
                <div className={styles.disclaimer}>
                  By publishing a new revision of this process I confirm, that this process page and
                  all documentation is up-to-date and does not require any modification.
                </div>
                <br />
                {/* Hidden checkbox for sending notification because they does not work how this feature should works */}
                <Checkbox styles={{root: {display: 'none'}}}
                disabled={false}
                label={"Send notification"}
                checked={sentNotification}
                onChange={(_, checked) => setSentNotification(!!checked)}
                                />
              </div>
              <FormFooter
                onCancel={dismiss}
                onSubmit={() => onApproveModal(sentNotification)}
                saveLabel="Publish and confirm process validity"
                addTooltip={
                  'Publish standard or major change and update the next review date. Notifications and comments are optional.'
                }
              />
            </ModalWithHeader>
  );
};
